'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('../../../../dist-es6/shared/domain/fatigueMeterType');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

NavigationButtonDirective=function(_BaseControllerBacked){_inherits(NavigationButtonDirective,_BaseControllerBacked);function NavigationButtonDirective(){_classCallCheck(this,NavigationButtonDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(NavigationButtonDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/navigationButtonDirective/navigationButtonTemplate'}},{key:'textBindings',get:function()

{return['destinationState','label','tfmLabel','wfmLabel']}},{key:'controller',get:function()

{return NavigationButtonDirectiveController}},{key:'$inject',get:function()

{return['$scope','breadcrumbsService','userService']}}]);return NavigationButtonDirective}(BaseControllerBackedDirective);let


NavigationButtonDirectiveController=function(){
function NavigationButtonDirectiveController($scope,breadcrumbsService,userService){var _this2=this;_classCallCheck(this,NavigationButtonDirectiveController);
this._$scope=$scope;
this._breadcrumbsService=breadcrumbsService;
this._userService=userService;

if(this.label&&_.exists(this.tfmLabel||this.wfmLabel||this.afmLabel)){
throw new Error('Cannot provide industry-specific labels when generic label is provided.');
}

const fatigueMeterType=_.get(this._userService,'currentUser.fatigueMeterType');

switch(fatigueMeterType){
case FatigueMeterType.Trucking:
this.label=this.tfmLabel;
break;
case FatigueMeterType.Workforce:
this.label=this.wfmLabel;
break;
case FatigueMeterType.Aviation:
this.label=this.afmLabel;
break;
default:
throw new Error(`Invalid FatigueMeterType found, unable to determine correct NavigationButonDirective label. Got: ${fatigueMeterType}`);}


this._refresh();
this._$scope.$watchCollection('controller._breadcrumbsService.crumbs',function(){return _this2._refresh()});
}NavigationButtonDirectiveController.prototype.

_refresh=function _refresh(){var _this3=this;
this._inDestinationStateOrSubState=_(this._breadcrumbsService.crumbs).some(function(c){return c.stateName===_this3.destinationState});
};_createClass(NavigationButtonDirectiveController,[{key:'inDestinationStateOrSubState',get:function()

{
return this._inDestinationStateOrSubState;
}}]);return NavigationButtonDirectiveController}();



module.exports=NavigationButtonDirective;
//# sourceMappingURL=navigationButtonDirective.js.map
